import TextField from '@Fields/TextField';
import SelectField from '@Fields/SelectField';

class PriceForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleButtonClickOnForm = this.handleButtonClickOnForm.bind(this);
        this.buildPriceEvaluation = this.buildPriceEvaluation.bind(this);
        this.buildHLATable = this.buildHLATable.bind(this);
        this.updateHLAValues = this.updateHLAValues.bind(this);

        this.state = props.model;
    }

    componentWillReceiveProps(Props) {
        this.setState({
            Price: Props.model.Price,
            ForSale: Props.model.ForSale,
            LeasePrice: Props.model.LeasePrice,
            ForLease: Props.model.ForLease,
            ForFractional: Props.model.ForFractional,
            FractionalPrice: Props.model.FractionalPrice,
            FractionalPercent: Props.model.FractionalPercent,
            FractionalOwnershipPercentages: Props.model.FractionalOwnershipPercentages,
            CurrencyCodeSelected: Props.model.CurrencyCodeSelected,
            CurrencyCodeList: Props.model.CurrencyCodeList,
            DSInventoryLookupID: Props.model.DSInventoryLookupID,
            ValidFECategory: Props.model.ValidFECategory,
            FELink: Props.model.FELink,
            ShowFE: Props.model.ShowFE,
            TopLevelDomain: Props.model.TopLevelDomain,
            ExcludeGoodsAndServicesTax: Props.model.ExcludeGoodsAndServicesTax,
            ExcludeGoodsAndServicesTaxType: Props.model.ExcludeGoodsAndServicesTaxType,
            ExcludeGoodsAndServicesTaxExistingSetting: Props.model.ExcludeGoodsAndServicesTaxExistingSetting,
            FEClicks: Props.model.FEClicks,
            priceEvaluation: Props.model.priceEvaluation,
            EquipmentEventTypeID: Props.model.EquipmentEventTypeID,
            EquipmentNumberOfResults: Props.model.EquipmentNumberOfResults,
            EquipmentHigh: Props.model.EquipmentHigh,
            EquipmentLow: Props.model.EquipmentLow,
            EquipmentAverage: Props.model.EquipmentAverage,
            EquipmentAverageWithoutHighAndLow: Props.model.EquipmentAverageWithoutHighAndLow,
            AuctionEventTypeID: Props.model.AuctionEventTypeID,
            AuctionNumberOfResults: Props.model.AuctionNumberOfResults,
            AuctionHigh: Props.model.AuctionHigh,
            AuctionLow: Props.model.AuctionLow,
            AuctionAverage: Props.model.AuctionAverage,
            AuctionAverageWithoutHighAndLow: Props.model.AuctionAverageWithoutHighAndLow,
            TradeInHigh: Props.model.TradeInHigh,
            TradeInLow: Props.model.TradeInLow,
            DailyRentalPrice: Props.model.DailyRentalPrice,
            WeeklyRentalPrice: Props.model.WeeklyRentalPrice,
            MonthlyRentalPrice: Props.model.MonthlyRentalPrice,
            QueryString: Props.model.QueryString,
            Translations: Props.model.Translations,
            NextPageURL: Props.model.NextPageURL,
            Progress: Props.model.Progress,
            PageNames: Props.model.PageNames,
            ClassNamesForProgressBar: Props.model.ClassNamesForProgressBar,
            CurrentSite: Props.model.CurrentSite,
            key: 0,
            HighlightErrors: Props.model.HighlightErrors,
            FormErrors: Props.model.FormErrors,
            InputErrors: Props.model.InputErrors
        });
    }

    handleFieldChanged(field, value) {
        var state = this.state;
        state[field] = value;

        if (field == "Price" && (this.state.CurrentSite == "Controller" || this.state.CurrentSite == "Aviation Trader" || this.state.CurrentSite == "Controller EMEA")) {
            state["ForSale"] = true;
        }
        else if (field == "LeasePrice") {
            state["ForLease"] = true;
        }
        else if (field == "FractionalPrice") {
            state["ForFractional"] = true;
        }
        else if (field == "ExcludeGoodsAndServicesTax") {
            this.handleOnBlur(field, value, true);
        }

        this.props.handleFormUpdate(state);

        if (field == "CurrencyCodeSelected") {
            this.handleOnBlur(field, value, true);
        }
        else if (field == "FractionalPercent") {
            this.handleOnBlur(field, value, true);
        }
        else if (field == "ForSale") {
            this.handleOnBlur(field, value, true);
        }
        else if (field == "ForLease") {
            this.handleOnBlur(field, value, true);
        }
        else if (field == "ForFractional") {
            this.handleOnBlur(field, value, true);
        }
    }

    handleButtonClickOnForm(button) {
        var state = this.state;

        switch (button) {
            case "fe":
                var state = this.state;

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var response = JSON.parse(xhr.response);
                    state.FEClicks = response.oPriceViewModel.FEClicks;
                    this.props.handleFormUpdate(state);
                }.bind(this);

                xhr.open("POST", '/listinginput/price/IncrementFEClicks' + this.state.QueryString, true);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(state));

                window.open(state.FELink, '_blank');    //opens fleet evaluator link on a new tab
                break;
            case "hla":
                this.updateHLAValues(state)
                break;
        }
    }

    handleOnBlur(field, value, bIsValue) {
        this.props.handleOnBlur(field, value, bIsValue);
    }

    buildHLATable(state) {
        var priceEvaluation = [];

        if (state.ShowFE) {
            priceEvaluation.push(
                <div key="FELink" className="row fleetevaluator center-content">
                    <h3 id="lblSellEquipment" className="InputLabel">{this.getTranslation("SellEquipment")}</h3>
                    <a id="FELink">
                        <span id="lblGetEval" className="InputLabel">
                            Get a <img alt="FleetEvaluator" src="//media.sandhills.com/cdn/Images/Logos/FleetEvaluator/logo-small.png" /> Pricing Evaluation
                        </span>
                    </a>
                </div>
            );
        }

        //trade in value 
        var tradeInValues = ""
        if ((state.TradeInLow <= 0 || state.TradeInLow == null) && (state.TradeInHigh <= 0 || state.TradeInHigh == null)) {
            tradeInValues = this.getTranslation("NotAvailable") + "-" + this.getTranslation("NotAvailable");
        }
        else if (state.TradeInLow <= 0 && state.TradeInHigh > 0) {
            tradeInValues = this.getTranslation("NotAvailable") + "-" + "USD $" + state.TradeInHigh.toLocaleString();
        }
        else if (state.TradeInLow > 0 && state.TradeInHigh <= 0) {
            tradeInValues = "USD $" + state.TradeInLow.toLocaleString() + "-" + this.getTranslation("NotAvailable");
        }
        else if (state.TradeInLow > 0 && state.TradeInHigh > 0) {
            tradeInValues = "USD $" + state.TradeInLow.toLocaleString() + "-" + "USD $" + state.TradeInHigh.toLocaleString();
        }

        //if any values are 0
        var hlaExplanation = "";
        hlaExplanation = state.Translations["HighLowExplanation1"].replace(/&quot;/g, "\"") + " " +
            state.Translations["HighLowExplanation2"].replace(/&quot;/g, "\"") + " " +
            state.Translations["HighLowExplanation3"] + " " +
            state.Translations["HighLowExplanation4"] + " " +
            state.Translations["HighLowExplanation5"];

        var bHasValueErrors = false;
        if (state.AuctionNumberOfResults == 0 || state.EquipmentNumberOfResults == 0 || state.TradeInHigh == 0 || state.TradeInLow == 0) {
            bHasValueErrors = true;
        }

        //Format Prices
        var equipmentHigh = "";
        var equipmentLow = "";
        var equipmentAverage = "";
        var equipmentAverageWithoutHighAndLow = "";
        var auctionHigh = "";
        var auctionLow = "";
        var auctionAverage = "";
        var auctionAverageWithoutHighAndLow = "";

        if (state.CurrencyCodeSelected == "USD") {
            equipmentHigh = state.CurrencyCodeSelected + " $" + state.EquipmentHigh.toLocaleString();
            equipmentLow = state.CurrencyCodeSelected + " $" + state.EquipmentLow.toLocaleString();
            equipmentAverage = state.CurrencyCodeSelected + " $" + state.EquipmentAverage.toLocaleString();
            equipmentAverageWithoutHighAndLow = state.CurrencyCodeSelected + " $" + state.EquipmentAverageWithoutHighAndLow.toLocaleString();

            auctionHigh = state.CurrencyCodeSelected + " $" + state.AuctionHigh.toLocaleString();
            auctionLow = state.CurrencyCodeSelected + " $" + state.AuctionLow.toLocaleString();
            auctionAverage = state.CurrencyCodeSelected + " $" + state.AuctionAverage.toLocaleString();
            auctionAverageWithoutHighAndLow = state.CurrencyCodeSelected + " $" + state.AuctionAverageWithoutHighAndLow.toLocaleString();
        }
        else {
            equipmentHigh = state.CurrencyCodeSelected + " " + state.EquipmentHigh;
            equipmentLow = state.CurrencyCodeSelected + " " + state.EquipmentLow;
            equipmentAverage = state.CurrencyCodeSelected + " " + state.EquipmentAverage;
            equipmentAverageWithoutHighAndLow = state.CurrencyCodeSelected + " " + state.EquipmentAverageWithoutHighAndLow;

            auctionHigh = state.CurrencyCodeSelected + " " + state.AuctionHigh;
            auctionLow = state.CurrencyCodeSelected + " " + state.AuctionLow;
            auctionAverage = state.CurrencyCodeSelected + " " + state.AuctionAverage;
            auctionAverageWithoutHighAndLow = state.CurrencyCodeSelected + " " + state.AuctionAverageWithoutHighAndLow;
        }

        priceEvaluation.push(
            <div key="highLowAverage" className="fe-table">
                <div className="fe-row fe-head">
                    <div className="fe-column">

                    </div>
                    <div className="fe-column">
                        {this.getTranslation("AuctionPrice")}
                    </div>
                    <div className="fe-column">
                        {this.getTranslation("ForSalePrice")}
                    </div>
                </div>

                <div className="fe-row">
                    <div className="fe-column">
                        {this.getTranslation("TotalListings")}
                    </div>
                    <div className="fe-column">
                        {state.AuctionNumberOfResults}
                    </div>
                    <div className="fe-column">
                        {state.EquipmentNumberOfResults}
                    </div>
                </div>

                <div className="fe-row">
                    <div className="fe-column">
                        {this.getTranslation("HighestPrice")}
                    </div>
                    <div className="fe-column">
                        {state.AuctionHigh > 0 ? auctionHigh : ""
                        }
                    </div>
                    <div className="fe-column">
                        {state.EquipmentHigh > 0 ? equipmentHigh : ""
                        }
                    </div>
                </div>

                <div className="fe-row">
                    <div className="fe-column">
                        {this.getTranslation("LowestPrice")}
                    </div>
                    <div className="fe-column">
                        {state.AuctionLow > 0 ? auctionLow : ""
                        }
                    </div>
                    <div className="fe-column">
                        {state.EquipmentLow > 0 ? equipmentLow : ""
                        }
                    </div>
                </div>

                <div className="fe-row">
                    <div className="fe-column">
                        {this.getTranslation("AveragePrice")}
                    </div>
                    <div className="fe-column">
                        {state.AuctionAverage > 0 ? auctionAverage : ""
                        }
                    </div>
                    <div className="fe-column">
                        {state.EquipmentAverage > 0 ? equipmentAverage : ""
                        }
                    </div>
                </div>

                <div className="fe-row">
                    <div className="fe-column">
                        {this.getTranslation("AverageWOPrice")}
                    </div>
                    <div className="fe-column">
                        {state.AuctionAverageWithoutHighAndLow > 0 ? auctionAverageWithoutHighAndLow : ""
                        }
                    </div>
                    <div className="fe-column">
                        {state.EquipmentAverageWithoutHighAndLow > 0 ? equipmentAverageWithoutHighAndLow : ""}
                    </div>
                </div>
            </div>
        );

        priceEvaluation.push(
            bHasValueErrors ?
                <div key="hasValueErrors" className="center-content">
                    <strong>{this.getTranslation("TradeInError")}</strong>
                </div>
                :
                <p key="hasValueErrors" className="free-sub-box-content"></p>
        );

        priceEvaluation.push(
            <strong key="tradeInValues">{this.getTranslation("TradeInValue")}: <span className="orange">{tradeInValues}</span></strong>
        );

        priceEvaluation.push(
            <div key="hlaExplanation" className="free-sub-box-content">
                {hlaExplanation}
            </div>
        );

        state.priceEvaluation = priceEvaluation;
        this.props.handleFormUpdate(state);
    }

    updateHLAValues(state) {
        Spinner.Show($('#pagebody'), true);

        if (state == null)
            state = this.state;

        var that = this;
        setTimeout(function () {
            if (!state.ValidFECategory) {
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var response = JSON.parse(xhr.response);
                    Spinner.Remove();

                    WorthModal();

                    state.EquipmentEventTypeID = response.oPriceViewModel.EquipmentEventTypeID;
                    state.EquipmentNumberOfResults = response.oPriceViewModel.EquipmentNumberOfResults;
                    state.EquipmentHigh = response.oPriceViewModel.EquipmentHigh;
                    state.EquipmentLow = response.oPriceViewModel.EquipmentLow;
                    state.EquipmentAverage = response.oPriceViewModel.EquipmentAverage;
                    state.EquipmentAverageWithoutHighAndLow = response.oPriceViewModel.EquipmentAverageWithoutHighAndLow;

                    state.AuctionEventTypeID = response.oPriceViewModel.AuctionEventTypeID;
                    state.AuctionNumberOfResults = response.oPriceViewModel.AuctionNumberOfResults;
                    state.AuctionHigh = response.oPriceViewModel.AuctionHigh;
                    state.AuctionLow = response.oPriceViewModel.AuctionLow;
                    state.AuctionAverage = response.oPriceViewModel.AuctionAverage;
                    state.AuctionAverageWithoutHighAndLow = response.oPriceViewModel.AuctionAverageWithoutHighAndLow;

                    state.TradeInHigh = response.oPriceViewModel.TradeInHigh;
                    state.TradeInLow = response.oPriceViewModel.TradeInLow;

                    that.buildHLATable(state);
                }.bind(that);

                xhr.open("POST", '/listinginput/price/UpdateHighLowAvg' + state.QueryString, false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(state));
            }
        }, 10);
    }

    buildPriceEvaluation(state) {
        //High Low Average Table only gets built if our category is invalid
        // otherwise we just show Fleet Evaluator link
        var priceEvaluation = [];

        //some domains will not show FE so we will just show HLA table. Do not show anything FE Related.
        if (this.state.ShowFE) {
            if (this.state.ValidFECategory) {
                priceEvaluation.push(
                    <div key="FELink" className="row fleetevaluator center-content">
                        <h3 id="lblSellEquipment" className="InputLabel">{this.getTranslation("SellEquipment")}</h3>
                        <a id="FELink" onClick={(e) => { this.handleButtonClickOnForm("fe"); }} title={this.getTranslation("OpensInANewTab")} target="_blank">
                            <span id="lblGetEval" className="InputLabel">
                                Get a <img alt="FleetEvaluator" src="//media.sandhills.com/cdn/Images/Logos/FleetEvaluator/logo-small.png" /> Pricing Evaluation
                            </span>
                        </a>
                    </div>
                );
            }
            else {
                priceEvaluation.push(
                    <div key="hlaLink" className="row fleetevaluator center-content">
                        <h3 id="lblSellEquipment" className="InputLabel">{this.getTranslation("SellEquipment")}</h3>
                        <a id="FELink" onClick={(e) => { this.handleButtonClickOnForm("hla"); }}>
                            <span id="lblGetEval" className="InputLabel">
                                Get a <img alt="FleetEvaluator" src="//media.sandhills.com/cdn/Images/Logos/FleetEvaluator/logo-small.png" /> Pricing Evaluation
                            </span>
                        </a>
                    </div>
                );
            }
            state.priceEvaluation = priceEvaluation
            this.props.handleFormUpdate(state);
        }
        else {
            this.handleButtonClickOnForm("hla");
        }
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    render() {

        let currencyddl = [];
        for (let i = 0; i < this.state.CurrencyCodeList.length; i++) {
            currencyddl.push({ text: this.state.CurrencyCodeList[i], value: this.state.CurrencyCodeList[i] })
        };

        var ChkOrWhatsWorth = [];
        var PricesForController = [];
        var ForSaleOrRentPrices = [];

        let CurrencyCode =
            <div className="labels-right">
                <SelectField
                    id="CurrencyCodeSelected"
                    className={"currency-ddl"}
                    SmallSelect={true}
                    value={this.state.CurrencyCodeSelected}
                    values={currencyddl}
                    onFieldChanged={(e) => { this.handleFieldChanged("CurrencyCodeSelected", e); }}
                    error={this.state.HighlightErrors.CurrencyCodeSelected}
                    errorText={this.state.InputErrors.CurrencyCodeSelected}
                    hasLabel={true}
                    ariaLabelledBy="PriceLabel"
                />
            </div>;

        if ((this.state.CurrentSite == "Controller" ||
            this.state.CurrentSite == "Aviation Trader" ||
            this.state.CurrentSite == "Controller EMEA") &&
            !this.props.masterViewModel.IsAttachment) {

            let FractionalPercentOptions = [];
            FractionalPercentOptions.push({ value: "0", text: this.state.Translations["SelectFractionalOwnership"] });
            for (const percent of this.state.FractionalOwnershipPercentages) {
                FractionalPercentOptions.push({ value: percent, text: percent + " " + this.state.Translations["Ownership"] });
            }

            ChkOrWhatsWorth.push(
                <div className="label-left" key="WhatsItWorth" style={{ float: "left" }}>
                    <label htmlFor="Price" style={{ paddingRight: '10px' }} id="PriceLabel">
                        {this.getTranslation("Price")}
                    </label>
                    <TextField
                        id="ForSale"
                        type="checkbox"
                        value={this.state.ForSale}
                        onFieldChanged={(e) => { this.handleFieldChanged("ForSale", e); }}
                        inline={true}
                        hasLabel={true}
                    />
                    <label htmlFor="ForSale">{this.getTranslation("ForSale")}</label>
                </div>
            );

            ChkOrWhatsWorth.push(
                <div key="ForSalePrice" className="input-right" style={{ float: "left" }}>
                    <div className="input-left">
                        <TextField
                            type="number"
                            min="0"
                            AddCommas={true}
                            id="Price"
                            value={this.state.Price}
                            onFieldChanged={(e) => { this.handleFieldChanged("Price", e); }}
                            onBlur={(e) => { this.handleOnBlur("Price", e); }}
                            error={this.state.HighlightErrors.Price}
                            errorText={this.state.InputErrors.Price}
                            className="price-input"
                            hasLabel={true}
                        />
                    </div>
                    {CurrencyCode}
                </div>
            );

            PricesForController.push(
                <div key="priceForm">
                    <div className="additional-prices" onClick={(e) => { PriceOptionsToggle() }} style={{ marginTop: '5px' }}>
                        <div className="price-options">
                            <strong>{this.getTranslation("OtherPricingOptions")} <i className="fa fa-plus" aria-hidden="true"></i></strong>
                        </div>
                        <div className="price-options-2" style={{ display: 'none' }}>
                            <strong>{this.getTranslation("Close")} {this.getTranslation("OtherPricingOptions")} <i className="fa fa-minus" aria-hidden="true"></i></strong>
                        </div>
                    </div>
                    <div className="price-content">
                        <div className="expand">
                            <button role="link" type="button" className="closed spec-group-label preserveDefaultBehaviorWithTranslationEditor" id="LeaseGroup" onClick={(e) => { $("#addtlPrice-groupName-1").slideToggle(400); $("#LeaseGroup").toggleClass("closed expanded"); }}>{this.getTranslation("Leasing")}</button>
                        </div>
                        <div className="accordion cf" id="addtlPrice-groupName-1">
                            <div className="form-row cf" style={{ display: 'block' }}>
                                <label htmlFor="LeasePrice" style={{ paddingRight: "5px" }}>
                                    {this.getTranslation("MonthlyPrice")}:
                                </label>
                                <TextField
                                    id="ForLease"
                                    type="checkbox"
                                    value={this.state.ForLease}
                                    onFieldChanged={(e) => { this.handleFieldChanged("ForLease", e); }}
                                    inline={true}
                                    hasLabel={true}
                                />
                                <label htmlFor="ForLease">{this.getTranslation("ForLease")}</label>
                                <span style={{ paddingLeft: '5px' }}>
                                    ({this.state.CurrencyCodeSelected})
                                </span>
                                <div className="input-right">
                                    <div className="input-left">
                                        <TextField
                                            type="number"
                                            min="0"
                                            AddCommas={true}
                                            id="LeasePrice"
                                            value={this.state.LeasePrice}
                                            onFieldChanged={(e) => { this.handleFieldChanged("LeasePrice", e); }}
                                            onBlur={(e) => { this.handleOnBlur("LeasePrice", e); }}
                                            error={this.state.HighlightErrors.LeasePrice}
                                            errorText={this.state.InputErrors.LeasePrice}
                                            className="price-input"
                                            hasLabel={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="expand">
                            <button role="link" type="button" className="closed spec-group-label preserveDefaultBehaviorWithTranslationEditor" id="FractionalGroup" onClick={(e) => { $("#addtlPrice-groupName-2").slideToggle(400); $("#FractionalGroup").toggleClass("closed expanded"); }}>{this.getTranslation("FractionalOwnership")}</button>
                        </div>
                        <div className="accordion cf" id="addtlPrice-groupName-2">
                            <div className="form-row cf" style={{ display: 'block' }}>
                                <label id="FractionalPriceLabel" htmlFor="FractionalPrice" style={{ paddingRight: "5px" }}>
                                    {this.getTranslation("FractionalOwnershipPrice")}:
                                </label>
                                <TextField
                                    id="ForFractional"
                                    type="checkbox"
                                    value={this.state.ForFractional}
                                    onFieldChanged={(e) => { this.handleFieldChanged("ForFractional", e); }}
                                    inline={true}
                                    hasLabel={true}
                                />
                                <label htmlFor="ForFractional">{this.getTranslation("FractionalSale")}</label>
                                <span style={{ paddingLeft: '5px' }}>
                                    ({this.state.CurrencyCodeSelected})
                                </span>
                                <div style={{ float: 'left', width: '65%' }}>
                                    <TextField
                                        type="number"
                                        min="0"
                                        AddCommas={true}
                                        id="FractionalPrice"
                                        value={this.state.FractionalPrice}
                                        onFieldChanged={(e) => { this.handleFieldChanged("FractionalPrice", e); }}
                                        onBlur={(e) => { this.handleOnBlur("FractionalPrice", e); }}
                                        error={this.state.HighlightErrors.FractionalPrice}
                                        errorText={this.state.InputErrors.FractionalPrice}
                                        className="price-input"
                                        hasLabel={true}
                                    />
                                </div>
                                <div style={{ float: 'left', width: '35%', height: '41px' }}>
                                    <SelectField
                                        id="FractionalPercent"
                                        isPrice={true}
                                        value={this.state.FractionalPercent}
                                        values={FractionalPercentOptions}
                                        onFieldChanged={(e) => { this.handleFieldChanged("FractionalPercent", e); }}
                                        error={this.state.HighlightErrors.FractionalPercent}
                                        errorText={this.state.InputErrors.FractionalPercent}
                                        hasLabel={true}
                                        ariaLabelledBy="FractionalPriceLabel"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else if (this.state.CurrentSite != "AuctionTime" && this.state.CurrentSite != "AuctionValues") {
            var PriceLabelFor = this.state.CurrentSite == "RentalYard" ? "DailyRentalPrice" : "Price";

            ChkOrWhatsWorth.push(
                <label className="label-left" htmlFor={PriceLabelFor} key="WhatsItWorth" id="PriceLabel" style={{ float: "left" }} >
                    {this.state.CurrentSite == "RentalYard" ? this.getTranslation("RentalPrices") : this.getTranslation("Price")}
                </label>
            );

            if (this.state.CurrentSite == "RentalYard") {
                ForSaleOrRentPrices.push(
                    <div key="RentPrices" className="input-right" style={{ float: "right" }}>
                        <div className="input-left" style={{ display: "flex", gap: "3px" }}>
                            <TextField
                                placeholder={this.getTranslation("Daily")}
                                type="number"
                                min="0"
                                AddCommas={true}
                                id="DailyRentalPrice"
                                value={this.state.DailyRentalPrice}
                                onFieldChanged={(e) => { this.handleFieldChanged("DailyRentalPrice", e); }}
                                onBlur={(e) => { this.handleOnBlur("DailyRentalPrice", e); }}
                                error={this.state.HighlightErrors.Price}
                                errorText={this.state.InputErrors.Price}
                                className="price-input"
                                hasLabel={true}
                                ariaLabelledBy="PriceLabel"
                            />
                            <TextField
                                placeholder={this.getTranslation("Weekly")}
                                type="number"
                                min="0"
                                AddCommas={true}
                                id="WeeklyRentalPrice"
                                value={this.state.WeeklyRentalPrice}
                                onFieldChanged={(e) => { this.handleFieldChanged("WeeklyRentalPrice", e); }}
                                onBlur={(e) => { this.handleOnBlur("WeeklyRentalPrice", e); }}
                                error={this.state.HighlightErrors.Price}
                                errorText={this.state.InputErrors.Price}
                                className="price-input"
                                hasLabel={true}
                                ariaLabelledBy="PriceLabel"
                            />
                            <TextField
                                placeholder={this.getTranslation("Monthly")}
                                type="number"
                                min="0"
                                AddCommas={true}
                                id="MonthlyRentalPrice"
                                value={this.state.MonthlyRentalPrice}
                                onFieldChanged={(e) => { this.handleFieldChanged("MonthlyRentalPrice", e); }}
                                onBlur={(e) => { this.handleOnBlur("MonthlyRentalPrice", e); }}
                                error={this.state.HighlightErrors.Price}
                                errorText={this.state.InputErrors.Price}
                                className="price-input"
                                hasLabel={true}
                                ariaLabelledBy="PriceLabel"
                            />
                        </div>
                        {CurrencyCode}
                    </div>
                );
            }
            else {
                ForSaleOrRentPrices.push(
                    <div key="ForSalePrice" className="input-right" style={{ float: "left" }}>
                        <div className="input-left">
                            <TextField
                                type="number"
                                min="0"
                                AddCommas={true}
                                id="Price"
                                value={this.state.Price}
                                onFieldChanged={(e) => { this.handleFieldChanged("Price", e); }}
                                onBlur={(e) => { this.handleOnBlur("Price", e); }}
                                error={this.state.HighlightErrors.Price}
                                errorText={this.state.InputErrors.Price}
                                className="price-input"
                                hasLabel={true}
                            />
                        </div>
                        {CurrencyCode}
                    </div>
                );
            }
        }

        var isGSTOrVATTaxable = false;
        var isGSTOrVATTaxableMessage = "";
        var existingGSTOrVATSetting = this.state.ExcludeGoodsAndServicesTaxExistingSetting ?? "";
        var GSTVATOptionList = [];

        if (this.state.ExcludeGoodsAndServicesTaxType != "") {
            isGSTOrVATTaxable = true;
            if (existingGSTOrVATSetting == "") {
                isGSTOrVATTaxableMessage = this.getTranslation("PricesEnteredExcludeTax");
                GSTVATOptionList.push({ text: "----", value: "" });
                GSTVATOptionList.push({ text: this.getTranslation("Yes"), value: "Yes" });
                GSTVATOptionList.push({ text: this.getTranslation("No"), value: "No" });
                GSTVATOptionList.push({ text: this.getTranslation("Not Applicable"), value: "Not Applicable" });
            }
            else {
                if (existingGSTOrVATSetting == "Yes") {
                    isGSTOrVATTaxableMessage = this.getTranslation("PleaseExclude")
                }
                else if (existingGSTOrVATSetting == "No") {
                    isGSTOrVATTaxableMessage = this.getTranslation("PleaseInclude")
                }
                else if (existingGSTOrVATSetting == "Not Applicable") {
                    isGSTOrVATTaxableMessage = this.getTranslation("TaxNotApplicable")
                }
            }
        }

        return (
            <div className="PriceForm" style={{ marginTop: '10px' }} key="PriceForm">
                <div className="validationError">
                    <span>{this.state.FormErrors}</span>
                </div>
                <div className="fe-section cf">
                    <div className="form-row cf" style={{ display: 'block' }}>
                        {ChkOrWhatsWorth}
                        {ForSaleOrRentPrices}
                    </div>

                    {isGSTOrVATTaxable && existingGSTOrVATSetting == "" ?
                        <div className="form-row cf" style={{ display: 'block' }}>
                            <div className="input-right" style={{ float: "right" }}>
                                <label className="label-left" htmlFor="ExcludeGoodsAndServicesTax">{isGSTOrVATTaxableMessage}</label>
                                <SelectField
                                    id="ExcludeGoodsAndServicesTax"
                                    value={this.state.ExcludeGoodsAndServicesTax}
                                    values={GSTVATOptionList}
                                    onFieldChanged={(e) => { this.handleFieldChanged("ExcludeGoodsAndServicesTax", e); }}
                                    hasLabel={true}
                                />
                            </div>
                        </div>
                        :
                        isGSTOrVATTaxable && existingGSTOrVATSetting != "" ?
                            <div className="form-row cf" style={{ display: 'block' }}>
                                <strong>{isGSTOrVATTaxableMessage}</strong>
                            </div>
                            :
                            <></>
                    }
                    {this.state.CurrentSite != "AuctionTime" && this.state.CurrentSite != "AuctionValues" ?
                        this.props.masterViewModel.IsRearrangedDetailsPage ?
                            <div className="tip-text"><strong>{this.getTranslation("Tip")}: </strong>{this.getTranslation("IncludeAskingPrice")}</div>
                            :
                            <div className="tip-text"><strong>{this.getTranslation("Tip")}: </strong>{this.getTranslation("BestResultsAskingPrice")}</div>
                        : null
                    }
                    {PricesForController}
                </div>

                <div className="modal" id="worth-modal">
                    <div className="modal-content">
                        <div className="modal-head">
                            <h2>{this.getTranslation("HighLowAverage")}</h2>
                            <span className="close" onClick={(e) => { CloseModal(); }}><i className="fa fa-times" aria-hidden="true"></i></span>
                        </div>
                        <div className="modal-main">
                            {this.state.priceEvaluation}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PriceForm;
global.PriceForm = PriceForm;